import * as THREE from 'three'
import Experience from './Experience'

import fragmentShader from './shaders/background/fragment.glsl'
import vertexShader from './shaders/background/vertex.glsl'

export default class Background {
  constructor() {
    // Setup
    this.experience = new Experience()
    this.debug = this.experience.debug

    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder('Background')
      this.debugFolder.close()
    }

    // Resource
    this.scene = this.experience.backgroundScene

    this.setGeometry()
    this.setMaterial()

    this.mesh = new THREE.Mesh(this.geometry, this.material)
    this.scene.add(this.mesh)
  }

  setGeometry() {
    this.geometry = new THREE.PlaneGeometry(2, 2) // grande quanto tutto lo schermo clip-space
  }

  setMaterial() {
    this.backgroundProperties = {
      color: '#f5efe6'
    }

    this.material = new THREE.ShaderMaterial({
      uniforms: {
        color: { value: new THREE.Color(this.backgroundProperties.color) }
      },
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      depthWrite: false, // non scrivere nel depth buffer
      depthTest: false // non fare test di profondità
    })

    // Debug
    if (this.debug.active) {
      this.debugFolder
        .addColor(this.backgroundProperties, 'color')
        .name('Color')
        .onChange(v => {
          this.material.uniforms.color.value.set(v)
        })
    }
  }
}
